export const POOL_CONSTS = {
    GET_POOL: "GET_POOL",
    UPDATE_POOL_BY_ID: "UPDATE_POOL_BY_ID",
};
